<!-- Ported from the Polaris kit: src/product/components/HelpEmptyState.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand change (phase 6.0, 29/09): `actionLabel` may be empty (no button), for an empty state whose way out is
     elsewhere on the page (a search with no result, an agent without permission). -->
<script setup>
// The first time in an area: a faded preview of what it will look like, the title, a sentence about what it is for and one button to begin.
// The preview is decoration and is hidden from a screen reader; the words say everything.
import { Add16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from '../ui/empty';

defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  actionLabel: { type: String, default: '' },
});
const emit = defineEmits(['action']);
</script>

<template>
  <div
    class="relative overflow-hidden rounded-polaris-xl border border-solid border-polaris-border"
    data-help-empty
  >
    <div
      class="pointer-events-none absolute inset-0 grid content-start gap-2 p-4 h-32 overflow-hidden opacity-30 [mask-image:linear-gradient(to_bottom,black,transparent)]"
      aria-hidden="true"
    >
      <slot name="preview" />
    </div>
    <div class="relative pt-24">
      <Empty>
        <EmptyHeader>
          <EmptyTitle>{{ title }}</EmptyTitle>
          <EmptyDescription>{{ description }}</EmptyDescription>
        </EmptyHeader>
        <EmptyContent v-if="actionLabel">
          <Button type="button" @click="emit('action')">
            <Add16 aria-hidden="true" />{{ actionLabel }}
          </Button>
        </EmptyContent>
      </Empty>
    </div>
  </div>
</template>
